import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { UserStatusResponse } from 'services/tenantManagementService';
import { USER_STATUS_SET, USER_STATUS_FETCHING } from './action';

export const userStatusReducer = (state = new PersistItemsReducer<UserStatusResponse>(), action: PersistItemsActionType<UserStatusResponse> | FetchingActionType): PersistItemsReducer<UserStatusResponse> => {
	switch (action.type) {
		case USER_STATUS_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case USER_STATUS_SET:
			const { items } = action as PersistItemsActionType<UserStatusResponse>;

			const itemsMap: { [id: number]: UserStatusResponse } = items.reduce(
                (map: { [id: number]: UserStatusResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
